<template>
	<div class="widget-test-page">
		<div v-if="loading" class="test-page-loading test-page-loading--warm">
			<div class="test-page-loading__spinner"></div>
			<p class="test-page-loading__text">Loading...</p>
		</div>

		<div v-else class="widget-test-page__content">
			<div class="layout-placeholder layout-header">Header</div>
			<div class="layout-placeholder layout-hero">Hero Banner</div>
			<div class="layout-main">
				<div class="layout-placeholder layout-sidebar">Sidebar</div>
				<div class="layout-placeholder layout-content">Main Content</div>
			</div>
			<div class="layout-placeholder layout-section-a">Section A</div>
			<div class="layout-placeholder layout-section-b">Section B</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'WidgetLayoutGaBaseline',
	data() {
		return {
			loading: true,
			loadingTimer: null,
		};
	},
	mounted() {
		const delay = 2500 + Math.random() * 1000;
		this.loadingTimer = setTimeout(() => {
			this.loading = false;
		}, delay);
	},
	beforeDestroy() {
		if (this.loadingTimer) {
			clearTimeout(this.loadingTimer);
		}
	},
};
</script>

<style scoped>
.widget-test-page {
	min-height: 1700px;
	width: 100%;
}

.widget-test-page__content {
	min-height: 1700px;
	width: 100%;
}

.test-page-loading {
	position: fixed;
	inset: 0;
	z-index: 9999;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.96);
	pointer-events: all;
	cursor: wait;
	user-select: none;
}

.test-page-loading__spinner {
	width: 48px;
	height: 48px;
	border: 4px solid rgba(192, 57, 43, 0.2);
	border-top-color: #c0392b;
	border-radius: 50%;
	animation: test-page-spin 0.8s linear infinite;
}

.test-page-loading--warm .test-page-loading__text {
	color: #641e16;
}

.test-page-loading__text {
	margin-top: 16px;
	font-size: 15px;
	font-weight: 500;
	letter-spacing: 0.02em;
	animation: test-page-pulse 1.2s ease-in-out infinite;
}

@keyframes test-page-spin {
	to {
		transform: rotate(360deg);
	}
}

@keyframes test-page-pulse {
	0%,
	100% {
		opacity: 0.45;
	}

	50% {
		opacity: 1;
	}
}

.layout-placeholder {
	display: flex;
	align-items: center;
	justify-content: center;
	color: rgba(255, 255, 255, 0.9);
	font-size: 18px;
	font-weight: 600;
}

.layout-header {
	height: 120px;
	background-color: #641e16;
}

.layout-hero {
	height: 380px;
	background-color: #c0392b;
	margin-top: 8px;
}

.layout-main {
	display: flex;
	gap: 8px;
	margin-top: 8px;
	height: 520px;
}

.layout-sidebar {
	flex: 0 0 280px;
	background-color: #d35400;
}

.layout-content {
	flex: 1;
	background-color: #e59866;
}

.layout-section-a {
	height: 320px;
	background-color: #884ea0;
	margin-top: 8px;
}

.layout-section-b {
	height: 280px;
	background-color: #922b21;
	margin-top: 8px;
}
</style>
